import { createContext, useEffect, useState } from "react";
import App from "../App";

export const appContext = createContext<any>({});

export const AppContext = () => {
  // const [loggedIn, setLoggedIn] = useState<boolean>(true);
  const [pageId, setPageId] = useState<string>(() => {
    return localStorage.getItem("pageId") || "";
  });

  useEffect(() => {
    if (pageId) {
      localStorage.setItem("pageId", pageId);
    }
  }, [pageId]);

  return (
    <appContext.Provider
      value={{
        // loggedIn,
        pageId,
        setPageId,
        // setLoggedIn,
      }}
    >
      <App />
    </appContext.Provider>
  );
};
